/*
 * @Author       : 秦灵
 * @desc         : 组件描述
 * @Date         : 2024-08-27 14:01:33
 * @LastEditTime : 2024-10-25 14:36:30
 * @LastEditors  : shenqing
 * @FilePath     : \evalute-all\teaching_QualityService\src\util\commonality.js
 */
/* eslint-disable space-before-function-paren */
import { mapGetters } from "vuex";
export const commonality = {
  data() {
    return {
      // 弹窗值
      message: "",
      top: 50, // 提示高度
      textNull: "", // 网络异常
      windowWidth: "",
      isTimer: true,
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleWindowResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
  },
  computed: {
    ...mapGetters(["commonality"]),
    // 判断是否是移动端
    isMobile() {
      // console.log('--', this.windowWidth)
      if (this.windowWidth && this.windowWidth < 769) {
        return true;
      }
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isTouchDevice =
        "ontouchstart" in window || navigator.maxTouchPoints > 0;
      // console.log('--', userAgent, isTouchDevice)
      return (
        /android|iphone|ipad|ipod/i.test(userAgent) ||
        (isTouchDevice && this.windowWidth <= 1024)
      );
    },
    pathIndex() {
      // '/index'定向跳转
      return this.$route.path === "/index" ? "" : ["default"]; // 数组只对‘加载提示’起效
    },
    loginInfo() {
      return JSON.parse(sessionStorage.getItem("loginInfo")) || {};
    },
    show() {
      // 添加需要隐藏header的路由
      let pathWhiteLists = ["/login", "/tch-questionnaire"];
      for (let index = 0; index < pathWhiteLists.length; index++) {
        const path = pathWhiteLists[index];
        if (this.$route.path.includes(path)) {
          // 教师问卷pc端需要显示header（ 移动端不需要显示header）
          if (path === "/tch-questionnaire" && !this.isMobile) {
            return true;
          } else {
            return false;
          }
        }
      }
      // 头部header 不是登陆页面会一直存在
      let judge = !this.$route.path.includes("login");
      let judge2 = this.$route.name;
      return judge && judge2;
    },
    // 隐藏 header 中的 菜单
    hiddenMenu() {
      // 添加需要隐藏菜单的路由
      let pathWhiteLists = ["/tch-questionnaire"];
      for (let index = 0; index < pathWhiteLists.length; index++) {
        const path = pathWhiteLists[index];
        if (this.$route.path.includes(path)) {
          return true;
        }
      }
      return false;
    },
    // 隐藏 header 中的 角色切换按钮
    hiddenRoleBtn() {
      if (
        this.commonality.atUserInfo &&
        this.commonality.atUserInfo.userType === "STUDENT"
      ) {
        return true;
      }
      // 添加需要隐藏角色切换按钮的路由
      let pathWhiteLists = ["/tch-questionnaire"];
      for (let index = 0; index < pathWhiteLists.length; index++) {
        const path = pathWhiteLists[index];
        if (this.$route.path.includes(path)) {
          return true;
        }
      }
      return false;
    },
    // 隐藏 header 中的 消息按钮
    hiddenMsgBtn() {
      if (
        this.commonality.atUserInfo &&
        this.commonality.atUserInfo.userType === "STUDENT"
      ) {
        return true;
      }
      // 添加需要隐藏消息按钮的路由
      let pathWhiteLists = ["/tch-questionnaire"];
      for (let index = 0; index < pathWhiteLists.length; index++) {
        const path = pathWhiteLists[index];
        if (this.$route.path.includes(path)) {
          return true;
        }
      }
      return false;
    },
    // 隐藏 header 中的 系统管理入口
    hiddenSystem() {
      if (
        this.commonality.atUserInfo &&
        this.commonality.atUserInfo.userType === "STUDENT"
      ) {
        return true;
      }
      // 添加需要隐藏系统管理入口的路由
      let pathWhiteLists = ["/tch-questionnaire"];
      for (let index = 0; index < pathWhiteLists.length; index++) {
        const path = pathWhiteLists[index];
        if (this.$route.path.includes(path)) {
          return true;
        }
      }
      return false;
    },
    examineHeaderPd() {
      return !this.$route.path.includes("/index");
    },
    scrollbarOrder() {
      // 滚动框类型 切换
      let judge2 = this.$route.name;
      return !this.$route.path.includes("index") && judge2;
    },
    VXcommon() {
      return this.commonality || {};
    },
    computHei() {
      // 隐藏header且是移动端访问
      if (!this.show && this.isMobile) {
        return `100%`;
      }
      // 计算滚动框高度
      return `calc(100% - ${
        this.$address &&
        this.VXcommon.pathName &&
        this.VXcommon.pathName.headerWidth &&
        this.PDAnalyze &&
        this.PDresource
          ? "124px"
          : "64px"
      })`;
    },
    PDAnalyze() {
      // 显示 分析模块
      return this.$route.path === "/supervising";
      // return this.VXcommon.pathName && (this.VXcommon.pathName.path === '/supervising')
    },
    PDresource() {
      // 显示 资源模块
      return this.$route.path === "/resource";
      // return this.VXcommon.pathName && (this.VXcommon.pathName.path === '/resource')
    },
  },
  methods: {
    /**
     * 当窗口缩放时，动态调整自身大小
     */
    handleWindowResize() {
      if (this.isTimer) {
        this.isTimer = false;
        setTimeout(() => {
          this.windowWidth = window.innerWidth; // 更新窗口宽度
        }, 201);
        setTimeout(() => {
          this.isTimer = true;
        }, 500);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/util/commonality.js